<script>
    import {ArrayHelper} from "../../../helpers/ArrayHelper";
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import AdaptersDropdown from "../../../component/adapters/Dropdown.vue"
    import InputText from 'primevue/inputtext';
    import Checkbox from 'primevue/checkbox';
    import Textarea from 'primevue/textarea';
    import Button from 'primevue/button';
    import TemplatesLabelCounts from '../../../templates/LabelCounts.vue';
    import GroupReportApi from "../../../api/GroupReportApi";
    import alerts from "../../../mixins/Alerts";
    import RadioButton from "primevue/radiobutton";

    export default {
        mixins: [alerts],
        props: {
            base: {
                type: String,
                required: true
            },
            domains: {
                type: String,
                required: true,
            },
            maxDomains: {
                type: Number,
                required: true,
            },
        },
        data () {
            return {
                name: 'create-group-report-modal',
                loading: false,
                list: null,
                error: null,
                reportName: null,
                selectedBase: null,
                emptyReport: false,
                top: 10,
                bases: ArrayHelper.sortObjectsByNumericAttrAsc(this.$tm('lang.main.bases'), 'priority'),
            }
        },
        mounted() {
            let top = (new URL(window.location.href)).searchParams.get("top");
            if (top) {
                this.top = parseInt(top)
            }
            if(this.domains){
                this.list = this.domains.split(",").join("\n");
                this.onOpen();
            }
            this.selectedBase = this.base;
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group';
            },
            getData(){
                if(this.list){
                    return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => {return item != ""});
                }
                return [];
            },
            count() {
                return this.getData.length;
            },
            getListenerId() {
                return Listeners.KS_POPUP_CREATE_GROUP_REPORT_OPEN;
            },
        },
        methods: {
            create() {
                if (!this.emptyReport && this.count <= 1) {
                    this.error = this.$t('lang.group_report.dom_length_err');
                    return false;
                }

                this.loading = true;
                GroupReportApi
                    .createGroup({
                        domains: this.getData,
                        base: this.selectedBase,
                        name: this.reportName,
                        emptyReport: this.emptyReport,
                        top: this.top
                    })
                    .then(response => window.open(sprintf('/%s/group/%s', window.locale, response.rid), '_self'))
                    .catch(error => this.alertError(error.message))
                    .finally(() => this.loading = false);
            },

            onOpen() {
                this.$emitter.emit(this.getListenerId);
            },
        },
        components: {
            AdaptersDialog,
            InputText,
            Checkbox,
            Textarea,
            AdaptersDropdown,
            Button,
            RadioButton,
            TemplatesLabelCounts,
        }
    }
</script>
<template>
    <div>
        <Button :label="$t('lang.group_report.create_btn')" @click="onOpen" icon="pi pi-plus" size="small" />

        <AdaptersDialog
            :listener-id="getListenerId"
            :header="$t('lang.group_report.modal_header')"
            :loading="loading"
            :error-message="error"
            :button-agree-label="$t('lang.main.btn.create')"
            :callback-agree="create"
        >
            <template #content>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label for="reportName">{{$t('lang.group_report.name')}}</label>
                            <InputText
                                type="text"
                                v-model="reportName"
                                id="reportName"
                                :placeholder="$t('lang.group_report.name_placeholder')"
                                maxlength="128"
                            />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label>{{$t('lang.group_report.base')}}</label>
                            <AdaptersDropdown
                                v-model="selectedBase"
                                :options="bases"
                                option-label="caption"
                                option-value="name"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                    <div class="formgroup-inline">
                        <label>{{$t('lang.group_report.select_top')}}</label>
                        <div class="field-radiobutton">
                            <RadioButton v-model="top" inputId="top10" name="top" :value="10" />
                            <label for="top10">{{$t('lang.group_report.top10')}}</label>
                        </div>
                        <div class="field-radiobutton">
                            <RadioButton v-model="top" inputId="top50" name="top" :value="50" />
                            <label for="top50">{{$t('lang.group_report.top50')}}</label>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field-checkbox">
                            <Checkbox v-model="emptyReport" :binary="true" inputId="emptyReport" />
                            <label for="emptyReport">{{$t('lang.group_report.empty_report')}}</label>
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field mb-0">
                            <TemplatesLabelCounts :text="$t('lang.group_report.report_domains')" :count="count" :is-required="!emptyReport" :limit="maxDomains" />
                            <Textarea
                                v-model="list"
                                rows="8"
                                :disabled="emptyReport"
                                :placeholder="$t('lang.group_report.domains_placeholder')"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </AdaptersDialog>
    </div>
</template>

<style scoped>
:deep(.p-button) .pi {
    font-size: 0.8125rem;
}
</style>
